module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/payment_icon-b2ac3bf59c9b4cea1960188463e7c0ed.png";